module.exports = __webpack_public_path__ + "img/logoEscolaTransparent2.009e3bd7.svg";